module.exports = __webpack_public_path__ + "media/aldemir.f9e4346e.mp3";